<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
    <p style="color: white"> Please Wait Loading... </p>
</ngx-spinner>
<body>
    
</body>